import styled from 'styled-components';

export default styled.ul`
  display: block;
  width: 100%;
  list-style: none;
  padding: 20px 0;
  margin: 0;
`;
